import React from 'react';

import {  Switch as SwitchStyled } from './SwitchStyles';

type Props = {
  isActive: boolean;
};

export const Switch: React.FC<Props> = ({ isActive })  => <SwitchStyled isActive={isActive} />;
